import { Mail, MapPin,  Instagram, Linkedin ,Youtube, File} from 'lucide-react';
import { CountUp } from 'use-count-up';
import Bat from "../Asset/Batiment.jpg";
import { Link } from 'react-router-dom';
import logo from "../Asset/logo/LOGO LSL-Blanc Fond Blanc - HD.png";
const socialLinks = [
  {
    Icon: Instagram,
    url: 'https://www.instagram.com/lsl_lestudioled/', // Remplacez par votre lien Instagram
  },
  {
    Icon: Linkedin,
    url: 'https://www.linkedin.com/in/lsl-le-studio-led/', // Remplacez par votre lien LinkedIn
  },
  {
    Icon: Youtube,
    url: 'https://www.youtube.com/@lestudioledlsl9452', // Remplacez par votre lien LinkedIn
  },
  // Ajoutez d'autres réseaux sociaux si nécessaire
];


const Stat = ({ icon, value, label, color, tooltip, suffix = '', isActive, onHover }) => {
  return (
    <div
      className={`relative transition-all duration-300 ease-in-out ${
        isActive ? 'scale-110' : 'scale-90 opacity-70'
      }`}
      onMouseEnter={onHover}
    >
      <div className="flex flex-col items-center space-y-4">
        <div className={`text-4xl font-bold ${color}`}>
          <CountUp isCounting end={value} duration={2.5} />
          {suffix}
        </div>
        <div className={`w-4 h-40 rounded-full relative overflow-hidden ${color.replace('text-', 'bg-').replace('-500', '-200')}`}>
          <div
            className={`absolute bottom-0 w-full ${color.replace('text-', 'bg-')} transition-all duration-1000`}
            style={{ height: isActive ? '100%' : '0%' }}
          />
        </div>
        <div className={`p-4 rounded-full ${color.replace('text-', 'bg-')}`}>
          {icon}
        </div>
        <p className="text-gray-600 text-center font-medium w-32">{label}</p>
      </div>
      {isActive && (
        <div className="absolute left-0 transform -translate-x-full -translate-y-1/2 top-1/2 bg-gray-800 text-white p-4 rounded-lg shadow-lg w-64 ml-[-20px] transition-opacity duration-300">
          <p>{tooltip}</p>
        </div>
      )}
    </div>
  );
};

function Footer() {
  return (
    <footer className="w-full bg-[#3D3D3D] text-white relative overflow-hidden">
      {/* LED Light Effect Animation */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-[200%] h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent top-0 animate-slide" />
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Contact Section */}
          
          <div className="space-y-8">
          <img 
      src={logo}
      alt="Logo LED" 
      className="w-64 h-auto mx-auto ml-2" 
    />
            <h2 className="text-3xl font-bold relative inline-block">
              NOUS CONTACTER
              <div className="absolute -bottom-2 left-0 w-1/3 h-1 bg-yellow-400 animate-pulse" />
            </h2>

            <div className="space-y-4">
              <div className="flex items-center space-x-3 group">
                <div className="p-2 bg-[#565555] rounded-lg group-hover:bg-yellow-400 transition-colors duration-300">
                  <MapPin className="w-5 h-5 group-hover:animate-bounce" />
                </div>
                <a 
    href="https://www.google.com/maps/search/?api=1&query=33+Rue+de+Metz,+92700+Colombes"
    target="_blank"
    rel="noopener noreferrer"
    className="group-hover:text-yellow-400 transition-colors duration-300"
  >
    33 Rue de Metz, 92700 Colombes
  </a>
              </div>

              <div className="flex items-center space-x-3 group">
                <div className="p-2 bg-[#565555] rounded-lg group-hover:bg-yellow-400 transition-colors duration-300">
                  <Mail className="w-5 h-5 group-hover:animate-bounce" />
                </div>
                <a 
                  href="mailto:contact@lestudioled.com"
                  className="group-hover:text-yellow-400 transition-colors duration-300"
                >
                  Contact@lestudioled.com
                </a>
            
              </div>
              <div className="flex items-center space-x-3 group">
                <div className="p-2 bg-[#565555] rounded-lg group-hover:bg-yellow-400 transition-colors duration-300">
                  <File className="w-5 h-5 group-hover:animate-bounce" />
                </div>
             
                <a 
                  href="https://lslsas.zohodesk.com/portal/fr/newticket"
                  className="group-hover:text-yellow-400 transition-colors duration-300"
                >

                  Espace de support client

                </a>
              </div>
            </div>
          
            <div className="flex space-x-4">
  {socialLinks.map((social, index) => (
    <a
      key={index}
      href={social.url}
      target="_blank" // Ouvre le lien dans un nouvel onglet
      rel="noopener noreferrer" // Sécurité supplémentaire pour les liens externes
      className="p-3 bg-[#565555] rounded-lg hover:bg-yellow-400 transition-all duration-300 hover:scale-110 group"
    >
      <social.Icon className="w-5 h-5 group-hover:animate-pulse" />
    </a>
  ))}
</div>

          </div>

          {/* Logo Section with Enhanced LED Effect */}
          <div className="flex flex-col items-center space-y-6">
            <div className="relative group">
              {/* Image with LED glow effect */}
              <div className="relative">
                <img 
                  src={Bat} 
                  alt="Studio LED Building"
                  className="w-128 h-128 object-cover rounded-lg shadow-2xl"
                />
                {/* Animated glow effects */}
                <div className="absolute inset-0 rounded-lg">
                  <div className="absolute inset-0  animate-pulse-slow rounded-lg" />
                  <div className="absolute -inset-0.5 opacity-0 blur-xl group-hover:opacity-50 transition-opacity duration-500 animate-pulse-slow rounded-lg" />
                </div>
              </div>

              {/* Logo text with LED effect */}
             {/* Logo Section with Enhanced LED Effect */}
<div className="absolute -bottom-24 left-1/2 transform -translate-x-1/2 w-full text-center">
  <div className="relative inline-block">
    {/* Remplacement du texte par une image */}
    
    {/* LED glow behind image */}
    <div className="absolute -inset-2 opacity-20 blur-xl animate-pulse-slow rounded-full" />
  </div>
</div>

            </div>

            {/* Add spacing to account for absolute positioning of logo text */}
            <div className="h-16" />

            <Link 
      to="/contact" 
      className="px-6 py-3 bg-yellow-400 text-gray-900 font-bold rounded-lg hover:bg-yellow-300 transition-all duration-300 hover:scale-105 relative group mt-8 flex items-center justify-center"
    >
      NOUS CONTACTER
      <div className="absolute inset-0 bg-white opacity-20 rounded-lg scale-0 group-hover:scale-100 transition-transform duration-300" />
    </Link>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#565555] text-center text-sm text-white-500">
          <p>
            © LE STUDIO LED  2019 - 2025 | Tous droits réservés | 
            <Link to="/mentions-legales" className="text-yellow-400 hover:underline ml-1
">
            Mentions Légales
          </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

// function App() {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const stats = [
//     {
//       icon: <Leaf className="w-6 h-6 text-white" />,
//       value: 95000,
//       label: "De CO2 économisées",
//       color: "text-green-500",
//       tooltip: "Réduction significative de l'empreinte carbone grâce à nos solutions écologiques",
//       suffix: " T"
//     },
//     {
//       icon: <Battery className="w-6 h-6 text-white" />,
//       value: 90,
//       label: "D'Économies d'Énergie",
//       color: "text-yellow-500",
//       tooltip: "Optimisation majeure de la consommation énergétique",
//       suffix: "%"
//     },
//     {
//       icon: <LineChart className="w-6 h-6 text-white" />,
//       value: 200000,
//       label: "Points lumineux installés",
//       color: "text-gray-500",
//       tooltip: "Réseau d'éclairage intelligent déployé avec succès"
//     },
//     {
//       icon: <LightbulbIcon className="w-6 h-6 text-white" />,
//       value: 70000,
//       label: "LED pilotées",
//       color: "text-blue-500",
//       tooltip: "Système de contrôle intelligent pour un éclairage optimal"
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-gray-100 flex flex-col">
//       <div className="flex-1 flex items-center justify-center p-12">
//         <div className="flex space-x-12 items-center">
//           {stats.map((stat, index) => (
//             <Stat
//               key={index}
//               {...stat}
//               isActive={activeIndex === index}
//               onHover={() => setActiveIndex(index)}
//             />
//           ))}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

export default Footer;
